// 商机搜索输入框数据内容所属类型
export const BUSINESS_SEARCH_INPUT_OPTIONS = [
  {
    label: '商机名称',
    value: 'name',
  },
  {
    label: '客户名称',
    value: 'customerName',
  },
  {
    label: '客户编号',
    value: 'customerNo',
  },
  {
    label: '业务员',
    value: 'userName',
  },
];

// 商机保护期
export const PROTECT_PERIOD_OPTIONS = [
  {
    label: '0-30',
    value: '0-30',
  },
  {
    label: '31-60',
    value: '31-60',
  },
  {
    label: '61-90',
    value: '61-90',
  },
  {
    label: '90天以上',
    value: '90',
  },
];
